import React from 'react';
import { useContent } from '@/providers/ContentProvider';
import { Language } from '@/types/types';
import { Flex, Select, SelectProps } from '@mantine/core';
import LANGUAGES from '@/configs/languages';
import styles from '../Navbar.module.scss';

const renderSelectOption: SelectProps['renderOption'] = ({ option }) => {
	const Flag = LANGUAGES[option.value as Language].flag;

	return (
		<Flex gap="sm">
			<Flag w={25} h={18.75} />
			{option.label}
		</Flex>
	);
};

export const LanguageSelect: React.FC = () => {
	const { language, setLanguage } = useContent();

	const data = Object.entries(LANGUAGES).map(([lang, { name }]) => ({
		value: lang,
		label: name,
	}));

	const SelectedFlag = LANGUAGES[language].flag,
		selectedLanguageName = LANGUAGES[language].name;

	const handleChange: SelectProps['onChange'] = (lang) => {
		if (!lang) return;
		setLanguage(lang as Language);
	};

	return (
		<Flex gap="sm">
			<SelectedFlag w={25} h={18.75} />
			<Select
				w={`${selectedLanguageName.length + 2}ch`}
				searchable={false}
				value={language}
				data={data}
				onChange={handleChange}
				renderOption={renderSelectOption}
				comboboxProps={{
					position: 'left-start',
				}}
				classNames={{
					input: styles.selectInput,
					dropdown: styles.selectDropdown,
				}}
			/>
		</Flex>
	);
};
